import { render, staticRenderFns } from "./VolunteerLayout.vue?vue&type=template&id=80133a16&scoped=true&"
import script from "./VolunteerLayout.vue?vue&type=script&lang=js&"
export * from "./VolunteerLayout.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerLayout.vue?vue&type=style&index=0&id=80133a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80133a16",
  null
  
)

export default component.exports